/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Prices_Gifts_EyebrowInputs */

const en_prices_gifts_eyebrow = /** @type {(inputs: Prices_Gifts_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gifts`)
};

const es_prices_gifts_eyebrow = /** @type {(inputs: Prices_Gifts_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regalos`)
};

const de_prices_gifts_eyebrow = /** @type {(inputs: Prices_Gifts_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geschenke`)
};

const zh_prices_gifts_eyebrow = /** @type {(inputs: Prices_Gifts_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`礼物`)
};

const ar_prices_gifts_eyebrow = /** @type {(inputs: Prices_Gifts_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هدايا`)
};

const fr_prices_gifts_eyebrow = /** @type {(inputs: Prices_Gifts_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cadeaux`)
};

const vi_prices_gifts_eyebrow = /** @type {(inputs: Prices_Gifts_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quà tặng`)
};

const sw_prices_gifts_eyebrow = /** @type {(inputs: Prices_Gifts_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zawadi`)
};

const th_prices_gifts_eyebrow = /** @type {(inputs: Prices_Gifts_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ของขวัญ`)
};

const bs_prices_gifts_eyebrow = /** @type {(inputs: Prices_Gifts_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pokloni`)
};

const ja_prices_gifts_eyebrow = /** @type {(inputs: Prices_Gifts_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ギフト`)
};

const ko_prices_gifts_eyebrow = /** @type {(inputs: Prices_Gifts_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`선물`)
};

const pt_prices_gifts_eyebrow = /** @type {(inputs: Prices_Gifts_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Presentes`)
};

const it_prices_gifts_eyebrow = /** @type {(inputs: Prices_Gifts_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regali`)
};

const sv_prices_gifts_eyebrow = /** @type {(inputs: Prices_Gifts_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gåvor`)
};

const nl_prices_gifts_eyebrow = /** @type {(inputs: Prices_Gifts_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cadeaus`)
};

const da_prices_gifts_eyebrow = /** @type {(inputs: Prices_Gifts_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gaver`)
};

const nb_prices_gifts_eyebrow = /** @type {(inputs: Prices_Gifts_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gaver`)
};

const fi_prices_gifts_eyebrow = /** @type {(inputs: Prices_Gifts_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lahjat`)
};

const pl_prices_gifts_eyebrow = /** @type {(inputs: Prices_Gifts_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prezenty`)
};

const ru_prices_gifts_eyebrow = /** @type {(inputs: Prices_Gifts_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подарки`)
};

const tr_prices_gifts_eyebrow = /** @type {(inputs: Prices_Gifts_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hediyeler`)
};

const hi_prices_gifts_eyebrow = /** @type {(inputs: Prices_Gifts_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उपहार`)
};

const id_prices_gifts_eyebrow = /** @type {(inputs: Prices_Gifts_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hadiah`)
};

const ms_prices_gifts_eyebrow = /** @type {(inputs: Prices_Gifts_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hadiah`)
};

const cs_prices_gifts_eyebrow = /** @type {(inputs: Prices_Gifts_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dárky`)
};

const el_prices_gifts_eyebrow = /** @type {(inputs: Prices_Gifts_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Δώρα`)
};

const he_prices_gifts_eyebrow = /** @type {(inputs: Prices_Gifts_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מתנות`)
};

const af_prices_gifts_eyebrow = /** @type {(inputs: Prices_Gifts_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geskenke`)
};

const hu_prices_gifts_eyebrow = /** @type {(inputs: Prices_Gifts_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajándékok`)
};

/**
* | output |
* | --- |
* | "Gifts" |
*
* @param {Prices_Gifts_EyebrowInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const prices_gifts_eyebrow = /** @type {((inputs?: Prices_Gifts_EyebrowInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Prices_Gifts_EyebrowInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_prices_gifts_eyebrow(inputs)
	if (locale === "de") return de_prices_gifts_eyebrow(inputs)
	if (locale === "zh") return zh_prices_gifts_eyebrow(inputs)
	if (locale === "ar") return ar_prices_gifts_eyebrow(inputs)
	if (locale === "fr") return fr_prices_gifts_eyebrow(inputs)
	if (locale === "vi") return vi_prices_gifts_eyebrow(inputs)
	if (locale === "sw") return sw_prices_gifts_eyebrow(inputs)
	if (locale === "th") return th_prices_gifts_eyebrow(inputs)
	if (locale === "bs") return bs_prices_gifts_eyebrow(inputs)
	if (locale === "ja") return ja_prices_gifts_eyebrow(inputs)
	if (locale === "ko") return ko_prices_gifts_eyebrow(inputs)
	if (locale === "pt") return pt_prices_gifts_eyebrow(inputs)
	if (locale === "it") return it_prices_gifts_eyebrow(inputs)
	if (locale === "sv") return sv_prices_gifts_eyebrow(inputs)
	if (locale === "nl") return nl_prices_gifts_eyebrow(inputs)
	if (locale === "da") return da_prices_gifts_eyebrow(inputs)
	if (locale === "nb") return nb_prices_gifts_eyebrow(inputs)
	if (locale === "fi") return fi_prices_gifts_eyebrow(inputs)
	if (locale === "pl") return pl_prices_gifts_eyebrow(inputs)
	if (locale === "ru") return ru_prices_gifts_eyebrow(inputs)
	if (locale === "tr") return tr_prices_gifts_eyebrow(inputs)
	if (locale === "hi") return hi_prices_gifts_eyebrow(inputs)
	if (locale === "id") return id_prices_gifts_eyebrow(inputs)
	if (locale === "ms") return ms_prices_gifts_eyebrow(inputs)
	if (locale === "cs") return cs_prices_gifts_eyebrow(inputs)
	if (locale === "el") return el_prices_gifts_eyebrow(inputs)
	if (locale === "he") return he_prices_gifts_eyebrow(inputs)
	if (locale === "af") return af_prices_gifts_eyebrow(inputs)
	if (locale === "hu") return hu_prices_gifts_eyebrow(inputs)
	return en_prices_gifts_eyebrow(inputs)
});